import { render } from "./ImprestChiefPage.vue?vue&type=template&id=fd7857cc"
import script from "./ImprestChiefPage.vue?vue&type=script&lang=js"
export * from "./ImprestChiefPage.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__